import * as React from 'react';

import { Language } from 'ha/i18n';
import { WeWantToPayCTA, WeWantToPayModal } from 'ha/modules/WeWantToPay';
import Alertbar from 'ha/modules/Alertbar';
import AuthModal from 'ha/modules/AuthModal';
import NavBar from 'ha/modules/NavBar';
import NavBarBottom from 'ha/modules/NavBarBottom';
import Footer from 'ha/components/next/Footer';
import MediaQuery from 'ha/helpers/MediaQuery';
import NoSSR from 'ha/components/NoSSR';
import LoadFonts, { FontInfo } from 'ha/components/LoadFonts';
import { defaultFont } from 'ha/constants/FontInfo';

import StickyFooter from './StickyFooter';
import Meta from './Meta';
import Favicons from './Favicons';

interface Props {
  availableLanguages: Array<{
    code: Language;
    localisedText: string;
  }>;
  banner?: React.ReactNode;
  breadcrumbs?: React.ReactElement<{ withoutFirstSeparator: boolean }> | null;
  hasFooter?: boolean;
  noFollowFooter?: boolean;
  isAuthenticated: boolean;
  activeFonts?: FontInfo[];
}

const PageLayout: React.SFC<Props> = ({
  availableLanguages,
  banner,
  breadcrumbs,
  children,
  hasFooter = true,
  noFollowFooter = true,
  isAuthenticated,
  activeFonts = [defaultFont],
}) => (
  <StickyFooter>
    <Meta />
    <LoadFonts activeFonts={activeFonts} />
    <Favicons />
    <NoSSR>
      <Alertbar />
    </NoSSR>
    <NoSSR>{!isAuthenticated && <AuthModal />}</NoSSR>
    <NavBar breadcrumbs={breadcrumbs} isAuthenticated={isAuthenticated} />
    <NoSSR>
      <MediaQuery>
        {({ lg }) => (!lg && isAuthenticated ? <NavBarBottom /> : null)}
      </MediaQuery>
    </NoSSR>

    <div>
      {banner}
      <NoSSR>{isAuthenticated && <WeWantToPayCTA />}</NoSSR>
    </div>
    {children}
    {hasFooter ? (
      <Footer
        availableLanguages={availableLanguages}
        noFollow={noFollowFooter}
      />
    ) : null}
    <NoSSR>{isAuthenticated && <WeWantToPayModal />}</NoSSR>
  </StickyFooter>
);

export default PageLayout;
